class NortadaStorage {
  storage: Record<string, any> = {};

  private static _instance: NortadaStorage;

  constructor() {
    if (NortadaStorage._instance) {
      throw new Error("Singleton classes can't be instantiated more than once.");
    }
    NortadaStorage._instance = this;
  }

  setItem(key: string, item: any) {
    this.storage[key] = item;
  }

  getItem(key: string) {
    return this.storage[key];
  }

  removeItem(key: string) {
    delete this.storage[key];
  }

  clear() {
    this.storage = {};
  }

  getStorage() {
    return this.storage;
  }
}

export const nortadaStorage = new NortadaStorage();
